export type FreeContentSlug =
  | "programacao-para-iniciantes"
  | "metodo-pomodoro"
  | string;

type AutomationsType = {
  [key: string]: string;
};

export const automations: AutomationsType = {
  "programacao-para-iniciantes": "programming_for_beginners",
  "metodo-pomodoro": "pomodoro_method",
};

export type FreeContent = {
  title: string;
  description: string;
  link: string;
  tag: "ebook" | "video" | "curso" | "blog";
  slug: FreeContentSlug;
  image?: string;
  buttonTitle: ButtonsName;
};

export type ButtonsName =
  | "Baixar ebook"
  | "Assistir aula"
  | "Acessar material"
  | "Acessar curso";

const ebookButton: ButtonsName = "Baixar ebook";
const videoButton: ButtonsName = "Assistir aula";
export const blogButton: ButtonsName = "Acessar material";

export const freeContentItems: FreeContent[] = [
  {
    title: "Ebook | Programação para quem (ainda) não sabe nada de programação",
    description:
      "Com uma abordagem didática e acessível, você aprenderá sobre o mercado de programação, suas oportunidades e como você pode ingressar no mercado, de diferentes maneiras.",
    link: "/conteudos-gratuitos/programacao-para-iniciantes",
    tag: "ebook",
    slug: "programacao-para-iniciantes",
    image: "url(/images/programacao-iniciantes.webp) center",
    buttonTitle: ebookButton,
  },
  {
    title: "Ebook | Método Pomodoro - organize sua produtividade",
    description:
      "Com instruções claras e exemplos práticos, este ebook vai lhe mostrar como realizar tarefas com mais eficiência, reduzir a procrastinação e alcançar seus objetivos, seja na programação ou em qualquer área da sua vida.",
    link: "/e-book-pomodoro.pdf",
    tag: "ebook",
    slug: "metodo-pomodoro",
    image: "url(/images/pomodoro.webp) center",
    buttonTitle: ebookButton,
  },
  {
    title: "Vídeo | Como aprender a programar do zero: passo a passo",
    description:
      "Como aprender a programar passo a passo: Quer entrar em um mercado de trabalho que não para de crescer, mas não sabe por onde começar? Pela programação. A programação é uma das áreas que demandará quase 800 mil profissionais até 2025.",
    link: "https://youtu.be/vVLl8Clk8UU",
    tag: "video",
    slug: "",
    image: "url(http://img.youtube.com/vi/vVLl8Clk8UU/0.jpg) center",
    buttonTitle: videoButton,
  },
  {
    title: "Vídeo | 5 dicas para treinar a lógica de programação",
    description:
      "Lógica de programação é a organização coesa de uma sequência de instruções voltadas à resolução de um problema, ou à criação de um software ou aplicação. A lógica de programação é o conhecimento anterior a qualquer outro quando falamos em desenvolvimento web.",
    link: "https://youtu.be/7eFpBuWurjQ",
    tag: "video",
    slug: "",
    image: "url(http://img.youtube.com/vi/7eFpBuWurjQ/0.jpg) center",
    buttonTitle: videoButton,
  },
  {
    title: "Vídeo | 6 dicas para te ajudar na documentação de Dados",
    description:
      "Veja algumas dicas pra te ajudar e facilitar a Documentação de Dados nos seus projetos e estudos.",
    link: "https://youtu.be/uLaAilqEZOM",
    tag: "video",
    slug: "",
    image: "url(http://img.youtube.com/vi/uLaAilqEZOM/0.jpg) center",
    buttonTitle: videoButton,
  },
  {
    title: "",
    description: "",
    link: "",
    tag: "blog",
    slug: "",
    image: "",
    buttonTitle: blogButton,
  },
];

export const findContentBySlug = (slug: string) => {
  const content = freeContentItems.find(
    (content: any) => content.slug === slug
  );

  if (content) return content;
  else return undefined;
};
